//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PartsReplacementDrawer from "./modules/PartsReplacementDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'PartsReplacementList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    PartsReplacementDrawer: PartsReplacementDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/parts/replacement',
      pageTitle: '备耗更换',
      addDisabled: false,
      userTree: [],
      //人员信息
      // 表头
      isorter: {
        column: 'replace_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'replaceDate',
        colName: 'replace_date',
        title: '更换时间',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {// currentSiteId(value) {
    //   var ids = this.getTreeCurrentId()
    //   this.queryParam.scopeId = ids[1]
    //   this.queryParam.scope = ids[0]
    //   if (ids[0] == 1) {
    //     // 根据站点id
    //     this.addDisabled = false
    //     this.queryParam.siteId = ids[1]
    //     this.spliceColumn(this.siteColumn)
    //   } else {
    //     // 根据区域id
    //     this.addDisabled = true
    //     this.queryParam.siteId = undefined
    //     this.spliceColumn(this.siteColumn, 1)
    //   }
    //   this.delayLoadData()
    // },
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryParam.status = 1;
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateReplaceDate: function onDateReplaceDate(value, dateArray) {
      this.queryParam.replaceDateStart = dateArray[0];
      this.queryParam.replaceDateEnd = dateArray[1];
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    }
  }
};